module.exports = __webpack_public_path__ + "img/c5201811-1.d4340599.jpg";